export const RoleName: Record<string, string> = {
  MOVIMENTATION: 'Movimentação',
  WORKORDER: 'Orçamento',
  FINANCIAL: 'Financeiro',
  BANKINGENTRIES: 'Lançamento bancário',
  ACCOUNTRECEIVABLE: 'Contas a receber',
  ACCOUNTPAYABLE: 'Contas a pagar',
  QUOTATION: 'Cotação',
  MATERIAL: 'Material',
  PURCHASE: 'Compra',
  BILL: 'Conta',
  DASHBOARD: 'Dashboard',
  VIEW: 'Visualização',
  KIT: 'Kits',
  REGISTER: 'Cadastro',
  COMPANY: 'Empresa',
  EMPLOYEE: 'Funcionário',
  CONFIGURATION: 'Configuração',
  PROFILE: 'Perfil',
  CUSTOMER: 'Cliente',
  COSTCENTER: 'Centro de custo',
  PLANACCOUNT: 'Plano de conta',
  BANKACCOUNT: 'Conta bancária',
  DEFAULTPLANACCOUNT: 'Plano de conta padrão',
  USER: 'Usuário',
  INFORMATIVE: 'Informativo',
  ACCESSORY: 'Acessório',
  TASK: 'Serviço',
  AREA: 'Área',
  SUBAREA: 'Subárea',
  GROUP: 'Grupo',
  SUBGROUP: 'Subgrupo',
  CONSUMABLE: 'Insumos',
  MANUFACTER: 'Fabricante',
  PART: 'Peça',
  INSURER: 'Seguradora',
  SUPPLIER: 'Fornecedor',
  DOCUMENTTYPE: 'Tipo de documento',
  PAYMENT: 'Pagamento',
  DEFAULT: 'Padrão',
  NCM: 'NCM',
  REPORT: 'Relatório',
  PARTS: 'Peças',
  CRM: 'CRM',
  QUIZ: 'Questionário',
  QUESTION: 'Questão',
  RESPONSE: 'Resposta',
  ANSWER: 'Responder',
  MATRIX: 'Matrix',
  SENDOPTION: 'Opção de envio',
  EMAILTAG: 'Tag de e-mail',
  INVENTORY: 'Inventário',
  FISCAL: 'Fiscal',
  INVOICE: 'Nota fiscal',
  SALE: 'Venda',
  STONE: 'Stone',
  COUPON: 'Cupom fiscal',
  YARDMANAGEMENT: 'Gestão de Pátio',
  ACTIVITY: 'Atividades',
  DIARY: 'Diário',
  FOLLOWUP: 'Acompanhamento',
  EMPLOYEECOMMISSION: 'Comissão de funcionários',
  CLIENTAREA: 'Área do cliente',
  NOTIFICATION: 'Notificação',
  TEF: 'TEF',
  SPED: 'SPED',
  BOSCH: 'Bosch',
};
